import { useContext } from 'react';
import { ConfigContext } from 'src/contexts/ConfigContext';

const useConfig = () => {
	return useContext(ConfigContext);
};

export default useConfig;
